import { useMemo } from 'react';
import { useSplitClient } from 'modules/feature-flags';
import { flagLoading, resolveFlag, type ResolvedFlag } from './resolveFlag';
import type { FeatureFlag } from './featureFlags.generated';

export type SplitFlagWithConfig = ResolvedFlag;

/**
 * Like {useSplitFlag}, but also returns the treatment's dynamic config (the JSON
 * string set per treatment in the flag dashboard). Use this for flags whose
 * behaviour is driven by structured config rather than just on/off, e.g.
 * `SESSION_REPLAY_CONFIG`.
 */
export function useSplitFlagWithConfig(flagName: FeatureFlag): [SplitFlagWithConfig, boolean] {
  const [client, ready, timeout] = useSplitClient();
  const loading = flagLoading(ready, timeout);
  const resolved = useMemo(
    () => resolveFlag(client, ready, timeout, flagName, true),
    [client, ready, timeout, flagName]
  );
  return [resolved, loading];
}
